/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_MileageInputs */

const en_field_mileage = /** @type {(inputs: Field_MileageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mileage`)
};

const es_field_mileage = /** @type {(inputs: Field_MileageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kilometraje`)
};

const fr_field_mileage = /** @type {(inputs: Field_MileageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kilométrage`)
};

const de_field_mileage = /** @type {(inputs: Field_MileageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kilometerstand`)
};

const ja_field_mileage = /** @type {(inputs: Field_MileageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`走行距離`)
};

const zh_field_mileage = /** @type {(inputs: Field_MileageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`里程`)
};

const ar_field_mileage = /** @type {(inputs: Field_MileageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المسافة المقطوعة`)
};

const id_field_mileage = /** @type {(inputs: Field_MileageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jarak Tempuh`)
};

const it_field_mileage = /** @type {(inputs: Field_MileageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chilometraggio`)
};

const ru_field_mileage = /** @type {(inputs: Field_MileageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пробег`)
};

const pt_field_mileage = /** @type {(inputs: Field_MileageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quilometragem`)
};

const ko_field_mileage = /** @type {(inputs: Field_MileageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주행 거리`)
};

/**
* | output |
* | --- |
* | "Mileage" |
*
* @param {Field_MileageInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_mileage = /** @type {((inputs?: Field_MileageInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_MileageInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_mileage(inputs)
	if (locale === "es") return es_field_mileage(inputs)
	if (locale === "fr") return fr_field_mileage(inputs)
	if (locale === "de") return de_field_mileage(inputs)
	if (locale === "ja") return ja_field_mileage(inputs)
	if (locale === "zh") return zh_field_mileage(inputs)
	if (locale === "ar") return ar_field_mileage(inputs)
	if (locale === "id") return id_field_mileage(inputs)
	if (locale === "it") return it_field_mileage(inputs)
	if (locale === "ru") return ru_field_mileage(inputs)
	if (locale === "pt") return pt_field_mileage(inputs)
	return ko_field_mileage(inputs)
});